import { BasePage } from "@Tenants/Fun/Site/BasePage";
import { BaseSuggest } from "@Base/Blog/Suggest";

class Suggest extends BaseSuggest
{
	constructor()
	{
		super();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
	};
}

export class SuggestPage extends BasePage
{
	public Suggest: Suggest;

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.Suggest = new Suggest();
	};
}

const suggest = new SuggestPage();